import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// landIeul: components/CompanyDetail/LocalNavigation/index.tsx の react-scroll 相当。
// クリックで対象 id へスムーススクロール (offset -70)。
class SiteCompanyLocalNavigationController extends Controller {
  scrollTo(e: Event & { params: { target: string } }): void {
    e.preventDefault();
    const el = document.getElementById(e.params.target);
    if (!el) return;
    const y = el.getBoundingClientRect().top + window.scrollY - 70;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
}

application.register("site--company--local-navigation", SiteCompanyLocalNavigationController);
